module.exports = __webpack_public_path__ + "img/NATGAS_80X30.7aeb0952.png";